import React, { Component } from 'react';
import { Segment, Button, Image, Grid, Label, Form, Dimmer, Loader} from 'semantic-ui-react'
import rhprobanner from '../img/besttorhprobanner.png';
import rhprobotbanner from '../img/bannergray.png';
import { withRouter } from 'react-router';
import './ReviewPage.css';
import checkcomplete from '../img/checkcomplete.png';
import { store } from '../indexApp.js';
import { authContext, getToken } from '../adalConfig';
import { authAxios } from '../utils';
import { GetEmployeeInformationURL, SendEmailConfirmationURL, GetOfficeListingPointOfContactURL, CheckIfDateIsExceedTheMaxSlotURL, InsertPatchEmployeeAsyncURL } from '../constants';
import ProHeader from './Pro/ProHeader';
import ProFooter from './Pro/ProFooter'
import RHHeader from './Corp/RHHeader';
import RHFooter from './Corp/RHFooter';
import RHHeaderField from './Field/RHHeaderField'
import { translationsV2 } from '../translations';

let loginNameWithDomain = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';

class ReviewPage extends Component {
    constructor(props) {
        super(props)
        this.handleGoesBack = this.handleGoesBack.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleGoToHelp = this.handleGoToHelp.bind(this);
        this.handleCalClickBack = this.handleCalClickBack.bind(this);
        this.handleBacktoUserInfo = this.handleBacktoUserInfo.bind(this);
        this.handleBacktoCal = this.handleBacktoCal.bind(this);
        this.handleBacktoSelection = this.handleBacktoSelection.bind(this);
        this.handleUserComment = this.handleUserComment.bind(this);
        this.handleBacktoSoftware = this.handleBacktoSoftware.bind(this);
        this.handleSoftware = this.handleSoftware.bind(this);
        this.handleRouteButtons = this.handleRouteButtons.bind(this);
        this.handleReviewText = this.handleReviewText.bind(this);
    }

    state = {
        name: "",
        accountLogon: "",
        homeOffice: "",
        deliveryOffice: "",
        email: "",
        phoneNumber: "",
        computerModel: "",
        softwarePackages: "",
        upgradeWeek: "",
        phoneNumberAlternate: "",
        exceededMaxSlotDate: false,
        userRole: "",
        userComments: "",
        dockType: "",
        submitted: 'false',
        loading: false,
        isSubmitted: '',
        isAdmin: '',
        country: "",
        key: "",
        region: "",
        city: "",
        translations: {
        },
    }

    componentDidMount() {
        // This method is called when the component is first added to the document
        //this.ensureDataFetched();
        this.setState({
            loading: true
        })
        let loginNameWithDomain = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';
        if (!loginNameWithDomain) {
            this.props.history.push('./unauthorized');
            return;
        }
        authAxios.post(GetEmployeeInformationURL, {
            LoginNameWithDomain: loginNameWithDomain
        })
            .then(response => {
                let data = response.data;
                this.setState({
                    email: data.email, name: data.name, deliveryOffice: data.deliveryOffice,
                    phoneNumber: data.telephoneBusiness, homeOffice: data.homeOffice,
                    computerModel: data.currentSelectedComputerDevice, softwarePackages: this.isBase64(data.softwarePackages) ? atob(data.softwarePackages) : data.softwarePackages,
                    upgradeWeek: data.upgradeWeek, phoneNumberAlternate: data.telephoneAlternate,
                    accountLogon: data.loginName, userRole: data.userRole, /*cubicleNumer: data.cubicleNumber,*/
                    userComments: this.isBase64(data.userComments) ? atob(data.userComments) : data.userComments, dockType: data.currentSelectedDockDevice, isSubmitted: data.isSubmitted,
                    isAdmin: data.isAdmin, country: data.country, key: data.key, region: data.region, city: data.city
                })

                const country = this.state.country;

                // Load translations based on the country
                let translations = this.getTranslationsBasedOnCountry(country);
                if (translations) {
                    this.setState({
                        translations: translations
                    });
                }

                if (this.state.phoneNumber) {
                    this.setState({ phoneNumber: Number(this.state.phoneNumber.replace(/[^0-9]/g, '')) });
                }
                if (data.userRole === 'PROTIVITI') {
                    authAxios.get(GetOfficeListingPointOfContactURL + `?role=${this.state.userRole}`)
                        .then(response => {
                            let data = response.data;
                            let citiesCostCenters = data.map((s, i) => ({ city: s.city, costCenter: s.costCenter, country: s.country })).filter(_ => _.city && _.costCenter && _.country);
                            citiesCostCenters.push({
                                city: 'San Ramon',
                                costCenter: '90000',
                                country: 'US',
                            })
                            this.setState({
                                citiesCostCenters: this.updateOfficeListingCostCenterOptions(citiesCostCenters),
                                loading: false
                            });
                            let costCenterFromEmployeeDeliveryOffice = this.state.citiesCostCenters.filter(_ => _.key == this.state.deliveryOffice);
                            let costCenterFromEmployeeHomeOffice = this.state.citiesCostCenters.filter(_ => _.key == this.state.homeOffice);
                            if (costCenterFromEmployeeDeliveryOffice.length > 0) {
                                this.setState({
                                    deliveryOffice: costCenterFromEmployeeDeliveryOffice[0].value
                                })
                            }
                            if (costCenterFromEmployeeHomeOffice.length > 0) {
                                this.setState({
                                    homeOffice: costCenterFromEmployeeHomeOffice[0].value
                                })
                            }

                        });
                }
                else {
                    this.setState({
                        loading: false
                    })
                }
            })
            .catch((error) => {
                console.log('error ' + error);
                this.setState({
                    errorredirect: true
                });
                this.setState({
                    loading: false
                })
                this.props.history.push('./unauthorized');
            });
    }

    getCostCenterOptions() {
        authAxios.get(GetOfficeListingPointOfContactURL + `?role=${this.state.userRole}`).then((response) => {
            let data = response.data;
            let citiesCostCenters = data
                .map((s, i) => ({ city: s.city, costCenter: s.costCenter, country: s.country }))
                .filter((_) => _.city && _.costCenter && _.country);
            citiesCostCenters.push({
                city: "San Ramon",
                costCenter: "90000",
                country: "US",
            });
            this.setState({
                citiesCostCenters: this.updateOfficeListingCostCenterOptions(citiesCostCenters),
                loading: false,
            });
            let costCenterFromEmployeeDeliveryOffice = this.state.citiesCostCenters.filter(
                (_) => _.key == this.state.deliveryOffice
            );
            let costCenterFromEmployeeHomeOffice = this.state.citiesCostCenters.filter(
                (_) => _.key == this.state.homeOffice
            );
            if (costCenterFromEmployeeDeliveryOffice.length > 0) {
                this.setState({
                    deliveryOffice: costCenterFromEmployeeDeliveryOffice[0].value,
                });
            }
            if (costCenterFromEmployeeHomeOffice.length > 0) {
                this.setState({
                    homeOffice: costCenterFromEmployeeHomeOffice[0].value,
                });
            }
        });
    }

    getTranslationsBasedOnCountry(country) {
        const translations = translationsV2.find(t => t.language === country);
        if (translations) {
            return translations.translations;
        }
        return translationsV2.find(t => t.country === "United States").translations;
    }

    isBase64(str) {
        if (!str)
            return false;
        if (str === '' || str.trim() === '') { return false; }
        try {
            return btoa(atob(str)) == str;
        } catch (err) {
            return false;
        }
    }

    updateOfficeListingCostCenterOptions(source) {
        let sink = source.map((x, index) => {
            return ({
                key: x.city,
                text: "(" + x.costCenter + ") " + x.city + " - " + x.country,
                value: "(" + x.costCenter + ") " + x.city + " - " + x.country,
            })
        });
        return sink;
    }

    handleGoesBack() {
        this.props.history.goBack();
    }

    handleClick = async () => {
        // Going to Help=>Software page can allow progression to review page without delivery location or computer model.
        if (!this.state.userComments) {
            this.props.history.push('/userinformation');
        } else if (!this.state.computerModel) {
            this.props.history.push('/selectionCorp');
        }

        if (this.state.deliveryOffice && this.state.homeOffice) {
            this.setState({
                submitted: 'true'
            }, () => {
                let tempDeliveryOffice = this.state.deliveryOffice
                if (this.state.deliveryOffice.includes("-")) {
                    tempDeliveryOffice = this.state.deliveryOffice.split("-")[0].replace(/\s+$/g, '').split(') ')[1];
                }
                let tempHomeOffice = this.state.homeOffice;
                if (this.state.homeOffice.includes("-")) {
                    tempHomeOffice = this.state.homeOffice.split("-")[0].replace(/\s+$/g, '').split(') ')[1];
                }
                if (this.state.computerModel != 'Other') {
                    authAxios.post(CheckIfDateIsExceedTheMaxSlotURL, {
                        SoftwarePackages: this.state.softwarePackages, Email: this.state.email,
                        HomeOffice: tempHomeOffice,
                        DeliveryOffice: tempDeliveryOffice, isSubmitted: true,
                        LoginNameWithDomain: loginNameWithDomain, UpgradeWeek: this.state.upgradeWeek,
                        UserRole: this.state.userRole, Country: this.state.country

                    })
                        .then(response => {
                            this.setState({ exceededMaxSlotDate: false });
                            authAxios.post(SendEmailConfirmationURL, { SoftwarePackages: this.state.softwarePackages, HomeOffice: tempDeliveryOffice, Email: this.state.email, DeliveryOffice: tempDeliveryOffice, isSubmitted: true, LoginNameWithDomain: loginNameWithDomain })
                                .then(response => {
                                    authAxios.patch(InsertPatchEmployeeAsyncURL + this.state.key,
                                        [{
                                            "op": "replace",
                                            "path": '/isSubmitted',
                                            "value": true
                                        }]
                                    ).then(response => {
                                        this.props.history.push({
                                            pathname: './confirmation',
                                            state: {
                                                passedUserRole: this.state.userRole,
                                                passedRegion: this.state.region,
                                                passedCountry: this.state.country
                                            }
                                        });
                                    })
                                        .catch((error) => {
                                            console.log('error: ' + error);
                                        });


                                })
                                .catch((error) => {
                                    console.log('error ' + error);
                                    this.setState({
                                        errorredirect: true
                                    });
                                    this.props.history.push('./unauthorized');
                                });
                        })
                        .catch((error) => {
                            console.log('error ' + error);
                            this.setState({ exceededMaxSlotDate: true });
                        })
                }
                else {
                    authAxios.post(SendEmailConfirmationURL, { SoftwarePackages: this.state.softwarePackages, HomeOffice: tempDeliveryOffice, Email: this.state.email, DeliveryOffice: tempDeliveryOffice, isSubmitted: true, LoginNameWithDomain: loginNameWithDomain })
                        .then(response => {
                            let empDTO = {
                                isSubmitted: true, MondaySevenDaysReminderEmailFlag: true,
                                FiveDaysTrackingEmailFlag: true, ThursdayPriorToUpgradeWeekFlag: true
                            }
                            let results = [];
                            for (const property in empDTO) {
                                results.push({
                                    "op": "replace",
                                    "path": `${property}`,
                                    "value": `${empDTO[property]}`
                                })
                            }

                            authAxios.patch(InsertPatchEmployeeAsyncURL + this.state.key,
                                results
                            ).then(response => {
                                this.props.history.push({
                                    pathname: './confirmation',
                                    state: {
                                        passedUserRole: this.state.userRole,
                                        passedRegion: this.state.region,
                                    }
                                });
                            })
                                .catch((error) => {
                                    console.log('error: ' + error);
                                });

                        })
                        .catch((error) => {
                            console.log('error ' + error);
                            this.setState({
                                errorredirect: true
                            });
                            this.props.history.push('./unauthorized');
                        });
                }
            })

        }
    }

    handleGoToHelp() {
        this.props.history.push('./help');
    }

    handleCalClickBack() {
        if (this.state.region === 'EMEA')
            this.props.history.push('./calendar')
        else
            this.props.history.push('./software');

    }

    handleBacktoUserInfo() {
        this.props.history.push('./userinformation');
    }

    handleBacktoCal() {
        this.props.history.push('./calendar');
    }

    handleBacktoSoftware() {
        this.props.history.push('./software');
    }

    handleBacktoSelection() {
        if (this.state.userRole === 'PROTIVITI')
            this.props.history.push('./selection');
        else if (this.state.userRole === 'CORPORATE')
            this.props.history.push('./selectioncorp');
        else if (this.state.userRole === 'FIELD')
            this.props.history.push('./selectionfield')
    }

    DateExceededErrorMessage = () => {
        return (
            <React.Fragment>
                {this.state.exceededMaxSlotDate &&
                    <h2 className="errorreview" >
                        {this.state.translations.reviewDateExceededMessage}
                    </h2>
                }
            </React.Fragment>
        )
    }

    handleRouteButtons() {
        if (!this.state.isSubmitted || this.state.isAdmin) {
            return (
                <React.Fragment>
                    <Button className="backbuttonrev" onClick={this.handleCalClickBack}>  <i class="left arrow icon"></i> {this.state.translations.buttonBackText} </Button>
                    <Button className="nextbuttonrev" onClick={this.handleClick} disabled={this.state.submitted === 'true'} > {this.state.translations.buttonSubmitText} </Button>
                </React.Fragment>
            )
        }
    }

    handelHelpButton() {
        if (this.state.region === 'NA') {
            return (
                <React.Fragment>
                    <Button className="helpbutton2" onClick={this.handleGoToHelp}> {this.state.translations.buttonHelpText}</Button>
                </React.Fragment>
            )
        }
    }

    handleHeaderSelection() {
        if (this.state.userRole === 'PROTIVITI')
            return <ProHeader />;
        else if (this.state.userRole === 'CORPORATE')
            return <RHHeader />;
        else if (this.state.userRole === 'FIELD')
            return <RHHeaderField />;
    }

    handleFooterSelection() {
        if (this.state.userRole === 'PROTIVITI')
            return <ProFooter/>;
        else if (this.state.userRole === 'CORPORATE' || this.state.userRole === 'FIELD')
            return <RHFooter/>;
    }

    handleReviewText() {
        if (this.state.isSubmitted && !this.state.isAdmin) {
            return (
                <React.Fragment>
                    <div className="reviewText">
                        <p>
                            {this.state.reviewMessage1}
                        </p>
                        <br/>
                        <p>
                            {this.state.reviewMessage2}
                        </p>
                    </div>
                </React.Fragment>
            )
        }
    }

    handleUserComment() {
        if (!this.state.region === 'EMEA' && this.state.userComments){
            return (
                <React.Fragment>
                    <Grid.Row className='rowAlignment'>
                        <Grid.Column width={6}>
                            <Label className="label-title">{this.state.reviewDeliveryLabel}: </Label>
                        </Grid.Column>
                        <Grid.Column>
                            <Label>{this.state.userComments}</Label>
                        </Grid.Column>
                    </Grid.Row>
                </React.Fragment>
            )
        }
    }

    handleCorpHardware() {
        if (this.state.userRole === 'CORPORATE') {
            return (
                <React.Fragment>
                    <Grid.Row className='rowAlignment'>
                        <Grid.Column width={6}>
                            <Label className="label-title">Dock Type: </Label>
                        </Grid.Column>
                        <Grid.Column>
                            <Label>{this.state.dockType}</Label>
                        </Grid.Column>
                    </Grid.Row>

                </React.Fragment>
            )
        }

        else if (this.state.userRole === 'PROTIVITI') {
            return (
                <React.Fragment>
                    <Grid.Row className='rowAlignment'>
                        <Grid.Column width={6}>
                            <Label className="label-title">Software Packages: </Label>
                        </Grid.Column>
                        <Grid.Column>
                            <Label>{this.state.softwarePackages}</Label>
                        </Grid.Column>
                    </Grid.Row>
                </React.Fragment>
            )
        }
    }

    handleEmeaTelephone() {
        const { phoneNumberAlternate } = this.state
        if (this.state.region === 'EMEA') {
            return (
                <React.Fragment>
                    <Grid.Row className='rowAlignment'>
                        <Grid.Column width={6}>
                            <Label className="label-title">{this.state.translations.telephoneLabel}: </Label>
                        </Grid.Column>
                        <Grid.Column>
                            <Label>{phoneNumberAlternate}</Label>
                        </Grid.Column>
                    </Grid.Row>
                </React.Fragment>
            )
        }
    }

    handleNATelephone() {
        const { phoneNumber, phoneNumberAlternate } = this.state
        if (this.state.region === 'NA') {
            return (
                <React.Fragment>
                    <Grid.Row className='rowAlignment'>
                        <Grid.Column width={6}>
                            <Label className="label-title">Telephone (business): </Label>
                        </Grid.Column>
                        <Grid.Column>
                            <Label>{phoneNumber}</Label>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row className='rowAlignment'>
                        <Grid.Column width={6}>
                            <Label className="label-title">Telephone (alternate): </Label>
                        </Grid.Column>
                        <Grid.Column>
                            <Label>{phoneNumberAlternate}</Label>
                        </Grid.Column>
                    </Grid.Row>
                </React.Fragment>
            )
        }
    }

    handleEmeaHome() {
        const { homeOffice } = this.state
        if (this.state.region === 'EMEA') {
            return (
                <React.Fragment>
                    <Grid.Row className='rowAlignment'>
                        <Grid.Column width={6}>

                            <Label className="label-title">{this.state.translations.reviewHomeOfficeLabel}: </Label>

                        </Grid.Column>

                        <Grid.Column>
                            <Label>{homeOffice}</Label>

                        </Grid.Column>

                    </Grid.Row>
                </React.Fragment>
            )
        }
    }

    handleUSHome() {
        const { homeOffice } = this.state
        if (this.state.region === 'NA') {
            return (
                <React.Fragment>
                    <Grid.Row className='rowAlignment'>
                        <Grid.Column width={6}>

                            <Label className="label-title">Home Office Location: </Label>

                        </Grid.Column>

                        <Grid.Column>
                            <Label>{homeOffice}</Label>

                        </Grid.Column>

                    </Grid.Row>
                </React.Fragment>
            )
        }
    }

    handleEmeaDelivery() {
        const { deliveryOffice } = this.state
        if (this.state.region === 'EMEA') {
            return (
                <React.Fragment>
                    <Grid.Row className='rowAlignment'>
                        <Grid.Column width={6}>
                            <Label className="label-title">{this.state.translations.reviewDeliveryLabel}: </Label>
                        </Grid.Column>
                        <Grid.Column>
                            <Label>{deliveryOffice}</Label>

                        </Grid.Column>
                    </Grid.Row>
                </React.Fragment>
            )
        }
    }

    handleUSDelivery() {
        const {deliveryOffice} = this.state
        if (this.state.region === 'NA') {
            return (
                <React.Fragment>
                    <Grid.Row className='rowAlignment'>
                        <Grid.Column width={6}>
                            <Label className="label-title">Delivery Location: </Label>
                        </Grid.Column>
                        <Grid.Column>
                            <Label>{deliveryOffice}</Label>

                        </Grid.Column>
                    </Grid.Row>
                </React.Fragment>
            )
        }
    }

    handleSoftware() {
        if (this.state.region === 'NA') {
            return (
                <React.Fragment>

                    <Grid.Row className='rowAlignment'>
                        <Grid.Column width={6}>
                            <Label className="label-title">Software Information: </Label>
                        </Grid.Column>
                        <Grid.Column>
                            <Label>For Software information please click the Software Page button below:</Label><button onClick={this.handleBacktoSoftware} className="softwarebuttonrev">Software Information</button>
                        </Grid.Column>
                    </Grid.Row>
                </React.Fragment>
            )
        }
    }

    render() {
        let selectedUpgradeDate = new Date(this.state.upgradeWeek).toLocaleDateString();
        if (this.state.loading)
            return (
                <div className="center-me">
                    <Dimmer active inverted>
                        <Loader size='huge'>Loading data...</Loader>
                    </Dimmer>
                </div>
            )
        const { name, accountLogon, homeOffice, deliveryOffice, email, phoneNumber, computerModel, softwarePackages, upgradeWeek, phoneNumberAlternate, userRole} = this.state;
        return (
            <div className='outer-container'>
                <div className="inner-container">
                    {this.handleHeaderSelection()}
                    {this.handleReviewText()}

                    <Segment.Group className="segment-container">
                        <Segment className={userRole === 'CORPORATE' || userRole === 'FIELD' ? "CORP-segment-header" : "PRO-segment-header"}>  {this.state.isSubmitted && !this.state.isAdmin ? '' : this.state.reviewSelections}</Segment>

                        <Segment>

                            <Grid columns={2}>
                                {/* Name */}
                                <button onClick={this.handleBacktoUserInfo} className="ui basic button" style={{ display: this.state.isSubmitted && !this.state.isAdmin ? 'none' : '' }}>
                                    <i class="icon pencil"></i>
                                    {this.state.translations.reviewEditUserLabel} </button>
                                <Grid.Row className='rowAlignment'>

                                    <Grid.Column width={6}>

                                        <Label className="label-title">{this.state.translations.nameLabel}: </Label>
                                    </Grid.Column>
                                    <Grid.Column>

                                        <Label>{name}</Label>

                                    </Grid.Column>
                                </Grid.Row>

                                {/*Email */}
                                <Grid.Row className='rowAlignment'>
                                    <Grid.Column width={6}>
                                        <Label className="label-title">{this.state.translations.emailLabel}: </Label>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Label>{email}</Label>
                                    </Grid.Column>
                                </Grid.Row>

                                {/* Account Logon */}
                                <Grid.Row className='rowAlignment'>
                                    <Grid.Column width={6}>
                                        <Label className="label-title">{this.state.translations.reviewAccountLoginLabel}: </Label>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Label>{accountLogon}</Label>
                                    </Grid.Column>
                                </Grid.Row>

                                {/* Phone # */}
                               {/* {this.handleEmeaTelephone()}*/}
                                {this.handleNATelephone()}

                                {/* Home Office */}
                                {this.handleEmeaHome()}
                                {this.handleUSHome()}


                                {/* Delivery Office */}
                                {this.handleEmeaDelivery()}
                                {this.handleUSDelivery()}


                                {/*this.handleCorpCube()*/}
                                {this.handleUserComment()}

                                {/* Computer Model  */}
                                <button onClick={this.handleBacktoSelection} class="ui basic button" style={{ display: this.state.isSubmitted && !this.state.isAdmin ? 'none' : '' }}>
                                    <i class="icon pencil"></i>
                                    {this.state.translations.reviewEditDeviceLabel} </button>
                                <Grid.Row className='rowAlignment'>

                                    <Grid.Column width={6}>

                                        <Label className="label-title">{this.state.translations.reviewComputerLabel}: </Label>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Label>{computerModel}</Label>

                                    </Grid.Column>
                                </Grid.Row>

                                {this.handleSoftware()}

                                {/* Upgrade Week */}
                                <button onClick={this.handleBacktoCal} class="ui basic button" style={{ display: this.state.isSubmitted && !this.state.isAdmin ? 'none' : '' }}>
                                    <i class="icon pencil"></i>
                                    {this.state.translations.reviewEditWeekLabel}
                                </button>
                                <Grid.Row className='rowAlignment'>
                                    <Grid.Column width={6}>
                                        <Label className="label-title">{this.state.translations.reviewUpgradeWeekLabel}: </Label>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Label>{selectedUpgradeDate}</Label>
                                    </Grid.Column>
                                </Grid.Row>

                            </Grid>
                        </Segment>
                    </Segment.Group>
                    <div className="bottomButtons">
                        {this.DateExceededErrorMessage()}
                        {this.handleRouteButtons()}

                        {this.handelHelpButton()}
                    </div>

                </div>
                {this.handleFooterSelection()}

            </div>
        );
    }
}

export default ReviewPage;
